import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            探索分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            八大分类，精准发现你喜爱的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl p-6 flex flex-col items-center gap-3 border border-background-200/60 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center bg-background-100 group-hover:bg-primary-50 transition-colors`}>
                <i className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">
                热门
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}